import { render, staticRenderFns } from "./shop-category-seo.vue?vue&type=template&id=688c74e1&"
import script from "./shop-category-seo.vue?vue&type=script&lang=js&"
export * from "./shop-category-seo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports